import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Button, CloseButton, Modal } from "react-bootstrap";
import { PriceIntelligence } from "../../utils/dataPI";
import InnerGradeComponent from "../pricing/InnerGrade";
import arrow from "../../assets/images/pricing/arrow.svg";
import DispersionComponent from "../pricing/Dispersion";
import UndertoneComponent from "../pricing/Undertone";
import InfoModal from "../infoModal/infoModal";
import { externalApiInstance } from "../../config/axios";
import { LoaderResult } from "../pricing/desktopAdvancePricing";
import "./iduEditor.css";
import backArrow from "../../assets/images/pricing/back-arrow.svg";
import { getScaleForImage, getShapeForImage } from "../../utils/commonFunction";
import { clientPath } from "../../config/key";
import { get_ratio, getPolishAndSymmetryValue } from "../../utils/function";
// import { calculateTrueFaceUsp } from "../../utils/sheet_function";
import { diamondDepth } from "../../utils/diamondData";
import Loader from "../loader/loader";

const IduEditor = () => {
  const [infoPopupData, setInfoPopupData] = useState();
  const [show, setShow] = useState(false);
  const [infoModal, setInfoModal] = useState(false);
  const [step, setStep] = useState(2);
  const [searchParams] = useSearchParams();
  const [pricestepData, setPricestepData] = useState({});

  const [resultWaiting, setResultWaiting] = useState(false);
  const [result, setResult] = useState(null);
  const [updateIdu, setUpdateIdu] = useState(
    searchParams.get("update_following_idu") === "true"
  );
  const [errMsg, setErrMsg] = useState("");
  const [origin_url] = useState(searchParams.get("origin_url"));
  const token = searchParams.get("token");
  const [requestId, setRequestId] = useState(searchParams.get("requestId") && !isNaN(searchParams?.get("requestId")) ? searchParams.get("requestId") : null);
  const [iframeLoading, setIframeLoading] = useState(false);
  const queryParams = [
    "carat_weight",
    "shape",
    "color",
    "saturation",
    "clarity",
    "fluorescence",
    "polish",
    "symmetry",
    "trueFaceUp",
    "singlePair",
    "colorInnerGrade",
    "colorDispersion",
    "colorUndertone",
  ];

  

  const showClientInfoError = async () => {
    try {
      const response = await externalApiInstance(token).get(
        `/api/check-client-info`
      );
      // console.log("memberType", searchParams.get("memberType"), "clientId", searchParams.get("clientId"), "clientIP", searchParams.get("clientIP"));
      return response?.data?.clientInfo  === "mandatory" && (!searchParams.get("memberType") || !searchParams.get("clientId")  ||!searchParams.get("clientIP") ) ? true : false
    } catch (error) {
      console.log("error", error);
    }
  }

  
  const fetchData = async (requestId) => {
    try {
      const response = await externalApiInstance(token).get(
        `/api/price-intelligence/request/${requestId}`
      );

      if (response?.data?.status !== 200) {
        setErrMsg(response?.data?.message);
        return null;
      }

      console.log("response?.data?.resultdata", response?.data);
      const priceFields = response?.data?.data?.priceFields;
      console.log("priceFields", priceFields);

      let pricestepData = {};
      for (const key in priceFields) {
        // console.log("key", key);
        // if (key === "length") {
        //   pricestepData[key] = priceFields[key];
        //   const face_up_text = calculateTrueFaceUp({
        //     shape: priceFields["shape"],
        //     Carat: priceFields["carat_weight"],
        //     length: priceFields["length"],
        //     width: priceFields["width"],
        //   })?.pi_face_up_text;

        //   if (face_up_text) {
        //     pricestepData["trueFaceUp"] = face_up_text?.replace(
        //       "Face-Up - ",
        //       ""
        //     );
        //   }
        // } else
        if (priceFields[key]) {
          pricestepData[key] = priceFields[key];
        }
      }
      console.log("pricestepData", pricestepData);
      return pricestepData;
    } catch (e) {
      setErrMsg(e.response?.data?.message || "Failed to fetch data");
      return null;
    }
  };

  const sendPrice = async (payload) => {
    console.log("payload", payload);
    if ( searchParams.get("memberType") && searchParams.get("clientId") && searchParams.get("clientIP") ) {
      payload.clientInfo ={
        memberType: searchParams.get("memberType"),
        clientId: searchParams.get("clientId"),
        clientIP: searchParams.get("clientIP"),
      }
    }
    setIframeLoading(true);
    try {
      // const IDU = JSON.parse(sessionStorage.getItem("selectedIdu"));

      const response = await externalApiInstance(token).post(
        `/api/price-intelligence/idu-editor/${requestId}`,
        { ...payload }
      );
      // console.log("response11", response);

      const {
        price_low_range,
        price_high_range,
        requestId: reqId,
      } = response?.data || {};
      if (price_low_range && price_high_range) {
        setIframeLoading(false);

        const calculatedResult = {
          update_following_idu: updateIdu,
          requestId: reqId,
          price_low_range: price_low_range,
          price_high_range: price_high_range,
          color_inner_grade:
            payload?.colorInnerGrade === "5" ? "4+" : payload?.colorInnerGrade,
          color_dispersion:
            payload?.colorDispersion === "5" ? "4+" : payload?.colorDispersion,
          color_undertone:
            payload?.colorUndertone === "5" ? "4+" : payload?.colorUndertone,
        };
        console.log(
          "Sending data to the Third party",
          JSON.stringify(calculatedResult)
        );
        const response = {
          type: "CALCULATION_RESULT",
          payload: calculatedResult,
        };
        window.parent.postMessage(response, origin_url);
      } else {
        setErrMsg(response?.data?.message || response?.data?.msg);
        setResultWaiting(false);
        setShow(false);
      }
    } catch (e) {
      setErrMsg(e.response?.data?.message || "Failed to fetch data");
    }
  };

  useEffect(() => {
    const initializeData = async () => {
      if (!token) {
        setErrMsg("Token is required");
        return;
      }

      if (!origin_url) {
        setErrMsg("Origin Url is required");
        return;
      }
      if (!/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i.test(origin_url)) {
        setErrMsg("Invalid origin url");
        return;
      }
      // check the clientInfo are required
   const isClientInfoRequired =  await  showClientInfoError();
  //  console.log("isClientInfoRequired", isClientInfoRequired);
   if(isClientInfoRequired){
    setErrMsg("Client info is required");
    return;
   }

      // Handle requestId case
      if (requestId) {
        try {
          const data = await fetchData(requestId); // Added await here
          console.log("data", data);
          if (data) {
            setPricestepData(data);
            setShow(true);
            setErrMsg("");
          }
        } catch (error) {
          setErrMsg("Failed to fetch data with requestId");
        }
        return;
      }

      // Process query parameters
      const length = searchParams.get("length");
      const width = searchParams.get("width");
      const size = searchParams.get("size");

      const updatePrice = { ...pricestepData };

      let hasError = false;
      for (const key of queryParams) {
        const paramValue = searchParams.get(key);

        if (paramValue) {
          updatePrice[key] = paramValue;
        } else if (
          key === "colorInnerGrade" ||
          key === "colorDispersion" ||
          key === "colorUndertone"
        ) {
          updatePrice[key] = "";
        } else if (key === "trueFaceUp" && length && width ) {
          continue;
        }else{
          hasError = true;
          break;
        }
    

      }
      console.log("updatePrice", updatePrice);
      if (hasError) {
        setErrMsg("Invalid parameters. Please provide the valid parameters");
        return;
      }

      if (length && width) {
        updatePrice["ratio"] = Number(width) / Number(length);
        updatePrice["length"] = length;
        updatePrice["width"] = width;
        try {
          const response = await externalApiInstance(token).post(
        `/api/pi-face-up/discover-true-face-up-manual`,
        {
          shape: updatePrice["shape"],
          Carat: updatePrice["carat_weight"],
          length,
          width,
        }
      );
      console.log("response", response);
      const face_up_text = response?.data?.pi_face_up_text;

      if (face_up_text) {
        updatePrice["trueFaceUp"] = face_up_text?.replace("Face-Up - ", "");
      }
        } catch (error) {
          console.error(error);
          // setShow(true);
          setErrMsg(error.response?.data?.message || "Your window timeout. Please try again.");
          return;

        }
        // const face_up_text = calculateTrueFaceUp({
        //   shape: updatePrice["shape"],
        //   Carat: updatePrice["carat_weight"],
        //   length,
        //   width,
        // })?.pi_face_up_text;

        // if (face_up_text) {
        //   updatePrice["trueFaceUp"] = face_up_text?.replace("Face-Up - ", "");
        // }
      } else if (size) {
        updatePrice["ratio"] = get_ratio(size, updatePrice["shape"]);
        updatePrice["size"] = size;
      } else {
        hasError = true;
      }

      updatePrice["polishAndSymmetry"] = getPolishAndSymmetryValue(
        updatePrice["polish"],
        updatePrice["symmetry"]
      );

      if (hasError) {
        setErrMsg("Invalid parameters. Please provide the valid parameters");
      } else {
        // console.log("updatePrice", updatePrice);
        setPricestepData(updatePrice);
        const IDU = JSON.parse(sessionStorage.getItem("selectedIdu"));
        const colorDispersion = searchParams.get("colorDispersion");
        const colorInnerGrade = searchParams.get("colorInnerGrade");
        const colorUndertone = searchParams.get("colorUndertone");
        // console.log("IDU", IDU, colorDispersion, colorInnerGrade, colorUndertone , Object?.keys(IDU)?.length);
        if (updateIdu && IDU && Object.keys(IDU).length > 0) {
          await sendPrice({
            ...updatePrice,
            ...IDU,
            
          });
          return;
        } else if (colorDispersion && colorInnerGrade && colorUndertone) {
          await sendPrice({
            ...updatePrice,
            colorDispersion: colorDispersion,
            colorInnerGrade: colorInnerGrade,
            colorUndertone: colorUndertone,

          });
          return;
        }
        setShow(true);
        setErrMsg("");
      }
    };

    initializeData();
    // eslint-disable-next-line
  }, [searchParams, token, origin_url]);

  useEffect(() => {
    window.addEventListener("message", (event) => {
      console.log("event.origin", event.origin);
      // if (event.origin !== "https://ld97yq.csb.app") return;

      console.log("Received data from parent:", event.data);
      if (event.data.type === "INITIAL_DATA") {
      }
    });

    return () => {
      window.removeEventListener("message", () => {});
    };
  });

  const handleApplyPrice = () => {
    if (updateIdu) {
      sessionStorage.setItem(
        "selectedIdu",
        JSON.stringify({
          colorDispersion: pricestepData?.colorDispersion,
          colorInnerGrade: pricestepData?.colorInnerGrade,
          colorUndertone: pricestepData?.colorUndertone,
        })
      );
    } else {
      sessionStorage.removeItem("selectedIdu");
    }
    const payload = {
      update_following_idu: updateIdu,
      requestId: requestId,
      price_low_range: result?.price_low_range,
      price_high_range: result?.price_high_range,
      color_inner_grade:
        pricestepData?.colorInnerGrade === "5"
          ? "4+"
          : pricestepData?.colorInnerGrade,
      color_dispersion:
        pricestepData?.colorDispersion === "5"
          ? "4+"
          : pricestepData?.colorDispersion,
      color_undertone:
        pricestepData?.colorUndertone === "5"
          ? "4+"
          : pricestepData?.colorUndertone,
    };
    console.log("Sending data to the Third party", JSON.stringify(payload));
    const response = {
      type: "CALCULATION_RESULT",
      payload: payload,
    };
    window.parent.postMessage(response, origin_url);
  };

  function getValueByField(fieldName) {
    setInfoModal(true);
    let infoData = PriceIntelligence.find((item) => item.field === fieldName);
    setInfoPopupData(infoData);
  }

  const handleNext = () => {
    if (step === 4) {
      calculatePrice();
    } else {
      setStep(step + 1);
    }
  };

  const calculatePrice = async () => {
    try {
      const payload = {
        ...pricestepData,
        colorDispersion: pricestepData?.colorDispersion,
        colorInnerGrade: pricestepData?.colorInnerGrade,
        colorUndertone: pricestepData?.colorUndertone,
      };

      if (Number(payload?.colorInnerGrade) === 5) {
        payload.colorInnerGrade = "4+";
      }

      if (
        Number(payload.colorUndertone) > 4 &&
        pricestepData?.color === "Yellow" &&
        pricestepData?.saturation !== "Fancy Deep"
      ) {
        payload.colorUndertone = String(
          8 - Number(pricestepData.colorUndertone)
        );
      }
      if (
        Number(pricestepData.colorUndertone) === 5 &&
        pricestepData?.color !== "Yellow"
      ) {
        payload.colorUndertone = "4+";
      }
      if (Number(pricestepData.colorDispersion) === 5) {
        payload.colorDispersion = "4+";
      }
      if (
        pricestepData?.saturation === "Fancy Deep" &&
        pricestepData.colorUndertone === "2"
      ) {
        payload.colorUndertone = "3";
      }

       if ( searchParams.get("memberType") && searchParams.get("clientId") && searchParams.get("clientIP") ) {
      payload.clientInfo ={
        memberType: searchParams.get("memberType"),
        clientId: searchParams.get("clientId"),
        clientIP: searchParams.get("clientIP"),
      }
    }
      
      setResultWaiting(true);
      const response = await externalApiInstance(token).post(
        `/api/price-intelligence/idu-editor/${requestId}`,
        { ...pricestepData, ...payload }
      );
      console.log("response", response);
      setTimeout(() => {
        setResultWaiting(false);
      }, 4500);
      const {
        price_low_range,
        price_high_range,
        requestId: reqId,
      } = response?.data || {};
      if (price_low_range && price_high_range) {
        setRequestId(reqId);
        setResult({
          price_low_range,
          price_high_range,
        });
      } else {
        setErrMsg(response?.data?.message || response?.data?.msg);
        setResultWaiting(false);
        setShow(false);
      }
    } catch (error) {
      setErrMsg(error.response?.data?.message || error?.response?.data?.msg);
      setResultWaiting(false);
      setShow(false);
      console.log("error", error);
    }
  };

  return (
    <>
      {iframeLoading && <Loader />}
      <div className="adjust-idu-container">
        <Modal
          show={show}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          // onHide={() => setShow(false)}

          className={`${
            !result && !resultWaiting
              ? "Idu_popup_container Idu_desktop_outer adjust-idu-model iframe-idu-model"
              : "adjust-idu-result-modal-result adjust-idu-model Idu_popup_container Idu_desktop_outer adjust-idu-model iframe-idu-model"
          }`}
        >
          {result && !resultWaiting && <div
            className="close-icon "
            onClick={() => setShow(false)}
            role="presentation"
          >
            <CloseButton />
          </div>}

          <Modal.Header className="col-12 idu-editor-header"></Modal.Header>

          {resultWaiting || result ? (
            <>
              {resultWaiting && (
                <div className="desktop-result-screen-container d-flex flex-column justify-content-center">
                  <div className="desktop-result-body m-auto">
                    <LoaderResult />
                  </div>
                </div>
              )}
              {result && !resultWaiting && (
                <div className="desktop-result-screen-container d-flex flex-column justify-content-center ">
                  <div className="desktop-result-screen">
                    <div className="desktop-result-body">
                      <div className="result-page-fcrf-logo">
                        <img
                          alt="logo1"
                          src={`${clientPath}/icons/FCRF_logo.svg`}
                        />
                      </div>

                      {/* <div className="desktop-result-top">
                        <p>Confidential</p>
                        {pricestepData?.giaReportNumber && (
                          <span className="report-with-gia">
                            {"GIA: " + pricestepData?.giaReportNumber}
                          </span>
                        )}
                        <span>Price ID#: {pricestepData?.jobNumber}</span>
                      </div> */}
                      <div className="desktop-result-mid">
                        <div
                          className={`diamond_result_img ${
                            pricestepData?.shape === "Pear" &&
                            "diamond_result_img_pear"
                          }`}
                          style={{
                            transform: `scaleY(${getScaleForImage(
                              pricestepData?.shape,
                              pricestepData?.ratio
                            )})`,
                          }}
                        >
                          <img
                            alt="logo1"
                            src={`${clientPath}/images/diamond-${pricestepData?.color?.toLowerCase()}-${getShapeForImage(
                              pricestepData?.shape
                            )}.svg`}
                          />
                        </div>
                        <p
                          style={{
                            fontWeight: 500,
                          }}
                        >
                          {/* {checkAssets && "Basic mode - "} */}
                          Details:
                        </p>
                        <p className="diamond-info">
                          <span style={{ whiteSpace: "nowrap" }}>
                            {pricestepData?.carat_weight}ct,
                          </span>{" "}
                          <span style={{ whiteSpace: "nowrap" }}>
                            {pricestepData?.saturation} {pricestepData?.color},
                          </span>{" "}
                          <span style={{ whiteSpace: "nowrap" }}>
                            {pricestepData?.shape},
                          </span>{" "}
                          <span style={{ whiteSpace: "nowrap" }}>
                            {pricestepData?.clarity},
                          </span>{" "}
                          <span style={{ whiteSpace: "nowrap" }}>
                            Inner Grade{" "}
                            <b style={{ fontWeight: 600 }}>
                              {pricestepData?.colorInnerGrade === "5"
                                ? "4+"
                                : pricestepData?.colorInnerGrade}
                            </b>
                            {", "}
                          </span>
                          <span style={{ whiteSpace: "nowrap" }}>
                            Dispersion{" "}
                            <b style={{ fontWeight: 600 }}>
                              {pricestepData?.colorDispersion === "5"
                                ? "4+"
                                : pricestepData?.colorDispersion}
                            </b>
                            {", "}
                          </span>
                          <span style={{ whiteSpace: "nowrap" }}>
                            Undertone{" "}
                            <b style={{ fontWeight: 600 }}>
                              {pricestepData?.colorUndertone === "5"
                                ? "4+"
                                : pricestepData?.colorUndertone}
                            </b>
                            {", "}
                          </span>
                          <span style={{ whiteSpace: "nowra" }}>
                            {isNaN(pricestepData?.trueFaceUp)
                              ? pricestepData?.trueFaceUp
                              : diamondDepth
                                  .find(
                                    (item) =>
                                      Number(item.Id) ===
                                      pricestepData?.trueFaceUp
                                  )
                                  ?.displayName?.replace("Face-Up - ", "")}

                            {/* {`${
                              (reportType === "byGia"
                                ? diamondDepth
                                : diamondDepthForManual
                              ).find(
                                // eslint-disable-next-line
                                (item) => item.Id == pricestepData?.trueFaceUp
                              )?.displayName
                            }`} */}
                          </span>
                        </p>
                      </div>
                      <div className="desktop-result-last">
                        <p>
                          Wholesale Price{" - Advance:"}
                          {/* {!checkAssets ? "- Advance" : "- Basic"}: */}
                        </p>
                        <h6>
                          ${result?.price_low_range} - $
                          {result?.price_high_range}
                          {/* {priceData?.length > 0
                    ? `${priceData[0]} - ${priceData[1]} `
                    : "0"}{" "} */}
                          <span>PC</span>
                        </h6>
                      </div>
                      <span className="last-span-text">
                        Prices may fluctuate over time with market trends and
                        are also contingent upon the accuracy of your input;
                        therefore, they should not be considered as a guarantee.
                        While the price range reflects values within the trade
                        with a relatively high accuracy, we recommend using the
                        prices only as a second opinion.
                      </span>
                      {/* <h6 className="report-text">
                Report generated on {formatDate()} | Last data update on March 15, 2026
              </h6>
              <h6 className="report-text-mobile">
                Report generated on {formatDate()}
              </h6> */}
                      <h6 className="report-text-mobile">
                        Last data update on March 15, 2026
                      </h6>

                      {/* <p className="export_text" 
              onClick={handleValueClick}>
                Export
              </p> */}
                    </div>

                    <div className="next-btn-grid next-btn-desk">
                      <Button
                        className="next-btn adu-btn adu-btn-desk"
                        onClick={() => {
                          setStep(2);
                          setResult(null);
                          // setUpdateIdu(false);
                        }}
                      >
                       <span>Adjust IDU</span>
                      </Button>
                      <Button className="next-btn" onClick={handleApplyPrice}>
                       <span> Apply Price</span>
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </>
          ) : (
            <>
              <Modal.Body>
                <Modal.Title
                  id="contained-modal-title-vcenter"
                  className="col-12 idu-editor-header"
                >
                  {step > 2 && (
                    <div
                      className="idu-editor-header-left"
                      onClick={() => {
                        if (step === 2) {
                          return;
                        } else {
                          setStep(step - 1);
                        }
                      }}
                    >
                      <img src={backArrow} alt="icon" />
                      <p>Back</p>
                    </div>
                  )}

                  <h6>
                    {pricestepData?.carat_weight}ct, {pricestepData?.saturation}{" "}
                    {pricestepData?.color}, {pricestepData?.shape},{" "}
                    {pricestepData?.clarity}, {pricestepData?.polishAndSymmetry}
                  </h6>
                  <h6>
                    Fluorescence-{pricestepData?.fluorescence},{" "}
                    {isNaN(pricestepData?.trueFaceUp)
                      ? pricestepData?.trueFaceUp
                      : diamondDepth
                          .find(
                            (item) =>
                              Number(item.Id) === pricestepData?.trueFaceUp
                          )
                          ?.displayName?.replace("Face-Up - ", "")}
                    , Ratio - {pricestepData?.ratio?.toFixed(2)}
                  </h6>

                  {/* <span
                    onClick={() => {
                      setShow(false);
                    }}
                  >
                    <img src={closeIcon} alt="crossIcon" />
                  </span> */}
                </Modal.Title>
              </Modal.Body>
              <Modal.Body>
                {step === 2 && (
                  <InnerGradeComponent
                    step={step}
                    setStep={setStep}
                    pricestepData={pricestepData}
                    setPricestepData={setPricestepData}
                    getValueByField={getValueByField}
                  />
                )}
                {step === 3 && (
                  <DispersionComponent
                    step={step}
                    setStep={setStep}
                    pricestepData={pricestepData}
                    setPricestepData={setPricestepData}
                    getValueByField={getValueByField}
                  />
                )}
                {step === 4 && (
                  <UndertoneComponent
                    step={step}
                    setStep={setStep}
                    pricestepData={pricestepData}
                    setPricestepData={setPricestepData}
                    getValueByField={getValueByField}
                  />
                )}
                {step === 4 && (
                  <div className="update-idu-following-calculations">
                    <div></div>
                    <input
                      type="checkbox"
                      name="following-calculations"
                      id="following-calculations"
                      className="d-none"
                      checked={updateIdu}
                      // disabled={!pricestepData?.colorUndertone}
                      onChange={(e) => {
                        setUpdateIdu(e.target.checked);
                        // sessionStorage.setItem(
                        //   "updateIdu", e.target.checked);
                      }}
                    />
                    <label for="following-calculations">
                      Update the IDU for the following calculations
                    </label>
                  </div>
                )}

                {step !== 1 && (
                  <div className="advance-idu-footer-section">
                    <div className="pricing-userlogin-content-btn advance-pricing-btn m-0">
                      <Button
                        onClick={() => handleNext()}
                        disabled={
                          step === 2
                            ? !pricestepData?.colorInnerGrade
                            : step === 3
                            ? !pricestepData?.colorDispersion
                            : step === 4
                            ? !pricestepData?.colorUndertone
                            : false
                        }
                      >
                        <span>{step === 4 ? "calculate" : "Next"}</span>
                      </Button>

                      {/* <Button onClick={sendDataToParent}>
                        Send to the iframe
                    </Button> */}
                    </div>
                    <div
                      className={`back-button-section d-${
                        step === 2 ? "none" : "flex"
                      } align-items-center`}
                      role="button"
                      onClick={() => {
                        if (step === 2) {
                          return;
                        } else {
                          setStep(step - 1);
                        }
                      }}
                    >
                      <Button className={`back-contain-btn `}>
                        <img src={arrow} alt="icon" />
                      </Button>
                      <p className={`p-0 m-0 back-text `}>Back</p>
                    </div>
                    <div className="idu-footer-section">
                      <p>
                        {step === 3
                          ? `Inner-grade ${
                              parseInt(pricestepData?.colorInnerGrade) === 5
                                ? "4+"
                                : pricestepData?.colorInnerGrade
                            }`
                          : step === 4
                          ? `Inner-grade ${
                              parseInt(pricestepData?.colorInnerGrade) === 5
                                ? "4+"
                                : pricestepData?.colorInnerGrade
                            }, Dispersion ${
                              parseInt(pricestepData?.colorDispersion) === 5
                                ? "4+"
                                : pricestepData?.colorDispersion
                            } `
                          : step === 5
                          ? `Inner-grade ${
                              parseInt(pricestepData?.colorInnerGrade) === 5
                                ? "4+"
                                : pricestepData?.colorInnerGrade
                            }, Dispersion ${
                              parseInt(pricestepData?.colorDispersion) === 5
                                ? "4+"
                                : pricestepData?.colorDispersion
                            }, Undertone ${
                              parseInt(pricestepData?.colorUndertone) === 5
                                ? "4+"
                                : pricestepData?.colorUndertone
                            } `
                          : ""}
                      </p>
                    </div>
                  </div>
                )}
                {infoModal && (
                  <InfoModal
                    infoModal={infoModal}
                    setInfoModal={setInfoModal}
                    heading={infoPopupData?.field}
                    infoTxt={infoPopupData?.info}
                    bg_remove_modal="bg_remove_modal adjust-idu-modal"
                  />
                )}
              </Modal.Body>
            </>
          )}
        </Modal>
        <Modal
          show={!!errMsg}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="info-modal back-modal error-modal idu-editor-modal"
        >
          <div className="close-btn"></div>
          <Modal.Body>
            <div className="back-modal-body err-modal">
              <h4>{errMsg}</h4>

              <div className="action-grid mt-3">
                <Button onClick={() => setErrMsg(false)}>close</Button>
              </div>
            </div>{" "}
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default IduEditor;
